import { ReactNode } from 'react';
import { Box, Grid } from '@mui/material';
import { Typography } from '@sm-dashboard/ui-components';

const DEFAULT_TITLE = 'יש למלא את השדות החסרים:';

type MissingFieldsMessageProps = {
  title?: string;
  fields: string[];
};

export const MissingFieldsMessage = ({ title, fields }: MissingFieldsMessageProps) => (
  <Box>
    {title ? (
      <Box sx={{ mb: 1, fontWeight: 600 }}>
        <Typography variant="body2">{title}</Typography>
      </Box>
    ) : null}
    <Grid container spacing={1}>
      {fields.map(label => (
        <Grid item xs={6} key={label}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Box component="span" sx={{ color: 'error.main', fontWeight: 700 }}>
              •
            </Box>
            <Typography variant="body2">{label}</Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
);

type MissingFieldsSnackbarSetter = (value: {
  open: true;
  severity: 'warning';
  message: ReactNode;
}) => void;

export const showMissingFieldsSnackbar = (
  setSnackbar: MissingFieldsSnackbarSetter,
  fields: string[],
  title = DEFAULT_TITLE
) => {
  setSnackbar({
    open: true,
    severity: 'warning',
    message: <MissingFieldsMessage title={title} fields={fields} />
  });
};
